<div id="header-navbar-wrapper">
  <ds-themed-header></ds-themed-header>

  <!-- Navy navigation bar: visible MD+ (768px+) for tablet & desktop -->
  <div class="eu-navbar-band d-none d-md-block">
    <nav class="container-fluid px-0"
         id="desktop-navbar-band"
         [attr.aria-label]="'nav.main.description' | translate">
      <div class="container">
        <div class="d-flex align-items-stretch eu-navband-inner">
          <ds-themed-navbar></ds-themed-navbar>
        </div>
      </div>
    </nav>
  </div>

  <!-- Mobile collapsible navbar -->
  <div *ngIf="(isMobile$ | async)"
       id="mobile-navbar-wrapper"
       [@slideMobileNav]="(isNavBarCollapsed$ | async) ? 'collapsed' : 'expanded'">
    <nav class="px-3"
         id="collapsible-mobile-navbar"
         [attr.aria-hidden]="(isNavBarCollapsed$ | async)"
         [attr.aria-label]="'nav.main.description' | translate">
      <ds-themed-navbar></ds-themed-navbar>
    </nav>
  </div>
</div>
